// extracted by css-extract-rspack-plugin
export default {"container":"_b7818b30","wrapper":"_95ad55e4","titleItalic":"_1f0d2e2d","boldText":"_f826bbcf","header":"_9b6fa748","description":"_2260d51","mobileBreak":"_6d101e8"};